export default {
    "Auth": {
        "region": "ap-northeast-1",
        "cookieStorage": {
            "domain": ".sinops.cloud",
            "expires": 1,
            "secure": false
        },
        "identityPoolId": "ap-northeast-1:8bb128f6-d71c-4308-ae30-2ece692a535a",
        "userPoolWebClientId": "5gfsnucj9fatbgul9lcmumij26",
        "userPoolId": "ap-northeast-1_0CxphyZZd"
    },
    "API": {
        "endpoints": [
            {
                "name": "common",
                "region": "ap-northeast-1",
                "endpoint": "https://r13upaace3.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            },
            {
                "name": "zaiko",
                "region": "ap-northeast-1",
                "endpoint": "https://r6br2ees77.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            },
            {
                "name": "delica",
                "region": "ap-northeast-1",
                "endpoint": "https://yreoy7vsk7.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            },
            {
                "name": "meat",
                "region": "ap-northeast-1",
                "endpoint": "https://p9u228e89a.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            },
            {
                "name": "kpi",
                "region": "ap-northeast-1",
                "endpoint": "https://vu0sf3vm36.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            },
            {
                "name": "fleqv",
                "region": "ap-northeast-1",
                "endpoint": "https://6rxyoos93k.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            },
            {
                "name": "kyakusu",
                "region": "ap-northeast-1",
                "endpoint": "https://uttorpig26.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            },
            {
                "name": "daily",
                "region": "ap-northeast-1",
                "endpoint": "https://6se3xi9f0d.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            },
            {
                "name": "grocery",
                "region": "ap-northeast-1",
                "endpoint": "https://8w1slpwxdh.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            },
            {
                "name": "multi",
                "region": "ap-northeast-1",
                "endpoint": "https://ljjl7tpmnf.execute-api.ap-northeast-1.amazonaws.com/Prod/v1"
            }
        ]
    },
    "Storage": {
        "common": {
            "bucket": "production-common-api-cloud-tempdata-bucket",
            "region": "ap-northeast-1"
        },
        "delica": {
            "bucket": "production-delica-api-filedownloadbucket",
            "region": "ap-northeast-1"
        },
        "kyakusu": {
            "bucket": "production-kyakusu-api-kyakusu-web-data",
            "region": "ap-northeast-1"
        },
        "meat": {
            "bucket": "production-meat-api-filedownloadbucket",
            "region": "ap-northeast-1"
        }
    }
}